import { usePaymentPlan } from "./components/PaymentPlan/hooks/usePaymentPlan";
import { usePaymentNavigation } from "./hooks/usePaymentNavigation";
import React from "react";
import { PaymentPlan } from "./components/PaymentPlan/PaymentPlan";
import { PaymentStep } from "./types/PaymentStep";
import { PaymentPlanLine } from "./components/PaymentPlanLine/PaymentPlanLine";

export const Payment = ({ paymentPlanLineId }) => {
  const { paymentPlan, currentPaymentPlanLine } =
    usePaymentPlan(paymentPlanLineId);
  const { step, onPrev, onNext } = usePaymentNavigation(currentPaymentPlanLine);

  if (!paymentPlan || !currentPaymentPlanLine) return <></>;

  switch (step) {
    default:
    case PaymentStep.PAYMENT_PLAN_LINE:
      return (
        <PaymentPlanLine
          paymentPlan={paymentPlan}
          currentPaymentPlanLine={currentPaymentPlanLine}
          navigateToPaymentPlan={onNext}
        />
      );
    case PaymentStep.PAYMENT_PLAN:
      return (
        <PaymentPlan
          paymentPlan={paymentPlan}
          currentPaymentPlanLine={currentPaymentPlanLine}
          onPrev={onPrev}
        />
      );
  }
};
